import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

const { FiRefreshCw, FiUsers } = FiIcons;

const PlayerDashboardHeader = ({ loading, lastUpdated, onRefresh }) => (
  <div className="flex items-center justify-between gap-3 flex-wrap">
    <div>
      <h2 className="text-xl sm:text-3xl font-black uppercase tracking-widest text-[#d8ceb3]">
        Player Performance Metrics
      </h2>
      <p className="text-[10px] text-[#658d71] font-bold uppercase tracking-widest mt-0.5">
        Boston Red Sox · {new Date().getFullYear()} Season
        {lastUpdated && ` · Updated ${lastUpdated.toLocaleTimeString()}`}
      </p>
    </div>
    <div className="flex items-center gap-2">
      <SafeIcon icon={FiUsers} size={18} className="text-[#a9c9b1]" />
      <button
        onClick={onRefresh}
        disabled={loading}
        className="flex items-center gap-1.5 border border-[#658d71] text-[#a9c9b1] hover:border-[#a9c9b1] hover:text-white text-[10px] font-bold uppercase tracking-widest px-3 py-1.5 transition-colors"
      >
        <SafeIcon icon={FiRefreshCw} size={12} className={loading ? 'animate-spin' : ''} />
        Refresh
      </button>
    </div>
  </div>
);

export default PlayerDashboardHeader;